import { render } from "./Container.vue?vue&type=template&id=45b644e0"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Layout/Container.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45b644e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45b644e0', __exports__)) {
    api.reload('45b644e0', __exports__)
  }
  
  module.hot.accept("./Container.vue?vue&type=template&id=45b644e0", () => {
    api.rerender('45b644e0', render)
  })

}


export default __exports__